//资金管理api
import {ServerPriceApi} from '@/group-cloud/network/ServerBizApi';
//资金调整类型
export const Adjust_Fund_Opts = [
    {id: 1, label: '资金充值'},
    {id: 2, label: '资金扣款'}
];

//账户类型
export const Account_Fund_Opts = [
    {id: 0, label: '预付款账户'},
    {id: 1, label: '达量奖励账户'},
    {id: 2, label: '门店补贴账户'},
    {id: 3, label: '返货账户'},
];

//资金变动类型(往来类型)
export const Concat_Fund_Opts = [
    {id: '1', label: '资金充值'},
    {id: '2', label: '资金扣款'},
    {id: '3', label: '订单扣款'},
    {id: '4', label: '订单退款'},
    {id: '5', label: '转账充值'}
];

export class FundManageApi {

    constructor() {
    }
    protected static groupUrl = '/data-dist/api/money/center';

    //查询资金列表信息
    public static async getFundList(data){
        let uri = this.groupUrl + '/loadPageFuzzyForClient';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //资金转账导入
    public static async importFundTransfer(data){
        let uri = this.groupUrl + '/';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //关闭资金账户
    public static async closeFundAccount(data){
        let uri = this.groupUrl + '/changeStats';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //资金账户调整
    public static async adjustFund(data){
        let uri = this.groupUrl + '/handleChangeMoneyAccount';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //查询资金往来列表
    public static async getFunConcatList(data){
        let uri = this.groupUrl + '/moneyRecord';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    //批量设置资金使用比例
    public static async setUserRebeatPercent(data){
        let uri = this.groupUrl + '/saveUserRebeatPercent';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    // 账户管理
    public static async editManageAccount(data){
        let uri = this.groupUrl + '/editManageAccount';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

    // 保存账户管理
    public static async saveManageAccount(data){
        let uri = this.groupUrl + '/saveManageAccount';
        return await ServerPriceApi.sendNoBase(uri, data);
    }
    //保证金详情
    public static async getBzjInfo(data){
        let uri = this.groupUrl + '/getBondMoney';
        return await ServerPriceApi.sendNoBase(uri, data);
    }

}


